// extracted by mini-css-extract-plugin
export default {"paragraph":"_3pDbw","button":"_1WTQx"};